var map = {
	"./android-icon.svg": 2180,
	"./app-img.png": 2181,
	"./app-qr-code-bg.png": 2182,
	"./apple-icon.svg": 2183,
	"./contact-bg.png": 2184,
	"./contact-us-bg.jpg": 2185,
	"./contact-us-main-bg.webp": 2186,
	"./qr-bg.png": 2187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2179;